import React from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';
export default function OfferPlannerModalHeaderInfo({ data, headerLabel }) {
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4", "data-testid": headerLabel },
        React.createElement("div", { className: "col-span-2" },
            React.createElement("div", { className: "font-semibold text-lg" }, headerLabel)),
        data.map(({ label, value }, index) => (React.createElement(DescriptionListItem, { key: index, label: label, labelClassName: "!text-black font-semibold" }, value)))));
}
